import $ from 'jquery';

export default function scrollTo(eleSelector, offset = 0) {
    if (!$(`${eleSelector}:visible`).length) {
        return;
    }

    $('html, body').animate({ scrollTop: $(`${eleSelector}:visible`).offset().top - offset }, 1000);
}



// WEBPACK FOOTER //
// ./src/js/utils/scroll-to.js